import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandSeparatorWithDecimals'
})
export class ThousandSeparatorWithDecimalsPipe implements PipeTransform {

  transform(nStr: any, digits: number = 2): any {
    if (nStr === '' || nStr == undefined || nStr == null) { return ''; }
    let x, x1, x2, rgx;

    // Sayıyı önce ondalıklı sayıya çeviriyoruz ve belirtilen digit sayısına göre formatlıyoruz
    nStr = parseFloat(nStr).toFixed(digits);

    // String olarak işlem yapıyoruz
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x[1];  // Kuruş kısmını (ondalık kısmı) alıyoruz
    rgx = /(\d+)(\d{3})/;

    // Binlik ayraç ekleniyor
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }

    return x1 + ',' + (x2 ? x2 : '0'.repeat(digits));
  }
}
